import React, { useEffect, useRef, useState } from 'react';
import { animate, useReducedMotion } from 'framer-motion';
interface AnimatedNumberProps {
  value: number;
  format: (n: number) => string;
}

/** Counts from the previous value to the new one when data changes */
export function AnimatedNumber({
  value,
  format
}: AnimatedNumberProps) {
  const reduce = useReducedMotion();
  const current = useRef(reduce ? value : 0);
  const [display, setDisplay] = useState(current.current);
  useEffect(() => {
    if (reduce) {
      current.current = value;
      setDisplay(value);
      return;
    }
    const controls = animate(current.current, value, {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: v => {
        current.current = v;
        setDisplay(v);
      }
    });
    return () => controls.stop();
  }, [value, reduce]);
  return <span data-id="element-99" data-mp="1ecinz5uskf6b">{format(display)}</span>;
}